// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3SbhK","amount":"Amount_amount__2QCp8","tip":"Amount_tip__3ybLE","tipHeader":"Amount_tipHeader__1iWbh","tipsWrap":"Amount_tipsWrap__1aLgv"};